import script from "./HomeCustomerLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCustomerLabel.vue?vue&type=script&setup=true&lang=js"

import "./HomeCustomerLabel.vue?vue&type=style&index=0&id=0d6a75d2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6a75d2"]])

export default __exports__